/* eslint-disable react/prop-types */
import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";
import { Grid, MenuItem, Select } from "@mui/material";
import Loading from "components/Loading";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import moment from "jalali-moment";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getCompany } from "services/company.routes";
import queryString from "utils/queryString";
import renderInputField from "utils/renderInputField";
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import React from "react";
import DeleteIcon from '@mui/icons-material/Delete';
export default function Fields({ method, information, setInformation, handleUpdate, submit }) {

    const handleChange = (event) => {
        const { name, value } = event.target;
        setInformation({ ...information, [name]: value });
    };
    const handleImageChange = (event) => {
        const { name, files } = event.target;
        setInformation({ ...information, [name]: files });
    };
    const [loading, setLoading] = useState(false)
    const [cursor, setCursor] = useState(null);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(false);
    const [companies, setCompanies] = useState([]);

    useEffect(() => {
        setLoading(true);
        const query = {
            cursor: cursor === null ? null : cursor,
        }
        getCompany(queryString(query), false, (isOk, data) => {
            if (!isOk) {
                setLoading(false);
                return toast.error(data.message)
            } else {
                if (page !== 0) {
                    setCompanies((prev) => ([...prev, ...data.data]));
                } else {
                    setCompanies(data.data);
                }
                setLoading(false);
                setCursor(data.meta.next_cursor === null ? '' : data.meta.next_cursor);
                if (data.meta.next_cursor !== null)
                    return setHasMore(true);

                else return setHasMore(false)
            }
        })
    }, [page]);

    const fetchMoreData = () => {
        if (loading) return;
        if (hasMore) {
            setPage(prevPage => prevPage + 1)
        }
    }
    const [selectedDate, setSelectedDate] = useState();
    const renderCustomInput = ({ ref }) => (
        <div ref={ref} style={{
            position: "relative",
            width: "100%"
        }}>
            <input
                readOnly
                value={selectedDate ? `${selectedDate?.year}/${selectedDate?.month}/${selectedDate?.day}` : ""}
                style={{
                    background: 'white',
                    padding: '8px 12px',
                    width: '100%',
                    border: '0.0625rem solid #d2d6da',
                    borderRadius: '0.5rem',
                    color: '#495057'
                }}
            />
            <DeleteIcon onClick={() => onSelectedDate(undefined)} style={{ color: "red", cursor: "pointer", position: "absolute", left: 5, top: 5 }} />
        </div>
    );
    const onSelectedDate = (value) => {
        const formatedDate = value ? `${value?.year}/${value?.month}/${value?.day}` : null
        setSelectedDate(value)
        setInformation({ ...information, "investment_started_at": formatedDate });
    }
    return (
        <SoftBox py={3}>
            <Loading loading={loading} />
            <SoftBox component="form" role="form">
                <Grid container spacing={3}>
                    {[
                        { label: "نام فرصت سرمایه گذاری", name: "name", type: "text", placeholder: "نام فرصت سرمایه گذاری", value: information.name },
                        { label: "توضیحات", name: "description", type: "text", placeholder: "توضیحات", value: information.description },
                        { label: "سود ماهانه", name: "monthly_roi", type: "text", placeholder: "بین 0و1", value: information.monthly_roi },
                        { label: "سود سالانه", name: "yearly_roi", type: "text", placeholder: "بین 0و1", value: information.yearly_roi }
                    ].map((field) => renderInputField(field.name, field.label, field.type, field.placeholder, information, handleChange))}
                    <Grid item xs={12} sm={6} xl={3}>
                        <SoftBox mb={1} ml={0.5}>
                            <SoftTypography component="label" variant="caption" fontWeight="bold">
                                شرکت
                            </SoftTypography>
                        </SoftBox>
                        <Select
                            name="company_id"
                            value={information.company_id || ""}
                            onChange={handleChange}
                            fullWidth
                            MenuProps={{
                                PaperProps: {
                                    style: { maxHeight: 200 },
                                    onScroll: (event) => {
                                        const bottom = Math.abs(event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight) < 1;
                                        if (bottom) {
                                            fetchMoreData();
                                        }
                                    }
                                },
                            }}
                        >
                            {companies.map((company) => (
                                <MenuItem key={company.id} value={company.id}>
                                    {company.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </Grid>
                    {[
                        { label: "وضعیت نمایش", name: "is_active", options: [{ value: "1", label: "فعال" }, { value: "0", label: "غیرفعال" }] },
                        { label: "آماده سرمایه گذاری", name: "is_open", options: [{ value: "1", label: "بله" }, { value: "0", label: "خیر" }] },
                        { label: "قفل", name: "locked", options: [{ value: "1", label: "بله" }, { value: "0", label: "خیر" }] },
                        {
                            label: "نوع", name: "type", options: [
                                { value: "2", label: "SMART_LOW" },
                                { value: "3", label: "SMART_MEDIUM" },
                                { value: "4", label: "SMART_HIGH" },
                                { value: "5", label: "SANDOGH" }
                            ]
                        },
                        {
                            label: "بازه تقسیم سود", name: "profit_period", options: [
                                { value: "1", label: "یک ماه" },
                                { value: "2", label: "دو ماه" },
                                { value: "3", label: "سه ماه" },
                                { value: "4", label: "شش ماه" },
                                { value: "5", label: "یک سال" }
                            ]
                        }
                    ].map((selectField, index) => (
                        <Grid item xs={12} sm={6} xl={3} key={index}>
                            <SoftBox mb={1} ml={0.5}>
                                <SoftTypography component="label" variant="caption" fontWeight="bold">
                                    {selectField.label}
                                </SoftTypography>
                            </SoftBox>
                            <Select name={selectField.name} value={String(information[selectField.name])} onChange={handleChange} fullWidth>
                                {selectField.options.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid>
                    ))}
                    <Grid item xs={12} sm={6} xl={3}>
                        <SoftBox mb={1} ml={0.5}>
                            <SoftTypography component="label" variant="caption" fontWeight="bold">
                                تاریخ شروع سرمایه گذاری
                            </SoftTypography>
                        </SoftBox>
                        <DatePicker
                            value={selectedDate}
                            onChange={onSelectedDate}
                            renderInput={renderCustomInput}
                            selectorStartingYear={Number(moment()?.locale("fa")?.format("YYYY"))}
                            selectorEndingYear={Number(moment()?.locale("fa")?.format("YYYY")) + 1}
                            shouldHighlightWeekends
                            locale="fa"
                            wrapperClassName="w-full"
                            calendarPopperPosition={"bottom"}
                            colorPrimary="#0fbcf9"
                            colorPrimaryLight="rgba(75, 207, 250, 0.4)"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} xl={3}>
                        <SoftBox mb={1} ml={0.5}>
                            <SoftTypography component="label" variant="caption" fontWeight="bold">
                                لوگو
                            </SoftTypography>
                        </SoftBox>
                        <input
                            name="logo"
                            onChange={handleImageChange}
                            type="file"
                            style={{
                                background: 'white',
                                padding: '8px 12px',
                                width: '100%',
                                border: '0.0625rem solid #d2d6da',
                                borderRadius: '0.5rem',
                                color: '#495057'
                            }}
                            placeholder="Images"
                            accept=".jpg,.jpeg,.png"
                        />
                    </Grid>
                </Grid>
                <SoftButton onClick={method !== "update" ? submit : handleUpdate} style={{ marginTop: 40 }} variant="gradient" color="info">
                    {method !== "update" ? "ثبت" : "آپدیت"}
                </SoftButton>
            </SoftBox>
        </SoftBox>
    );
}
